// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus {
  box-shadow: none !important;
  outline: none;
}

.documents_dashboard {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

.search_wrapper {
  height: 50px;
}

.search_span {
  background-color: white;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: gray;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.search_wrapper input {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.search_wrapper input:focus {
  box-shadow: none !important;
  outline: none;
  border: 1px solid lightgray !important;
  border-left: 0 !important;
}

.dashboard_search_btn,
.dashboard_add_filetype_btn {
  background-color: #27cdcd !important;
  border-radius: 10px !important;
  color: white !important;
}

.dashboard_upgrade_storage_btn {
  color: #2ccece !important;
  background-color: #edfafa !important;
  border-radius: 10px !important;
}

.add_doc_btn {
  width: 140px !important;
  height: auto;
  background-color: #27cdcd !important;
  border-radius: 10px !important;
  font-size: 12px;
  text-transform: capitalize;
}

.add_folder_btn {
  width: auto !important;
  height: auto;
  background-color: #edae49 !important;
  border-radius: 10px !important;
  font-size: 11px;
}

.bg_doc_theme {
  background-color: #27cdcd !important;
  color: white;
}

.add_folder_plus:hover {
  background-color: rgb(25, 196, 25) !important;
}

.add_folder_cross:hover {
  background-color: rgb(185, 9, 9) !important;
}

.tbl_container {
  border: 1px solid lightgray !important;
  padding-left: 10px;
  padding-bottom: 30px;
  border-radius: 10px !important;
}

.edited_img {
  object-fit: cover !important;
}

.edited_media {
  position: relative;
}

.edited_img_type {
  position: absolute;
  height: 30px !important;
  width: 30px !important;
}

.ftype_icon1 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {
  background-color: #725dff !important;
}

.ftype_icon2 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {
  background-color: #458df9 !important;
}

.ftype_icon3 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {
  background-color: #67ada4 !important;
}

.ftype_icon4 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {
  background-color: #df562e !important;
}

.disable_box_shadow:focus {
  box-shadow: none !important;
  outline: none !important;
  border: 1px solid lightgray !important;
}

.roles_image1 {
  height: 27px;
  width: 27px;
  left: 0;
}

.roles_image2 {
  height: 27px;
  width: 27px;
  margin-left: -12px;
}

.roles_image3 {
  height: 27px;
  width: 27px;
  margin-left: -12px;
}

.count_rounded {
  height: 25px;
  width: 25px;
  background-color: #27cdcd;
  color: white;
  border: 2px solid white;
  border-radius: 40px;
  margin-left: -10px;
  font-size: 80%;
}

.share_tab_btn_group {
  box-shadow: none !important;
  border-bottom: 1px solid lightgray;
}

.share_tab_btn_group .tab_btn {
  background-color: white !important;
  border-radius: 0 !important;
  color: gray;
  font-size: 18px;
  font-weight: bold;
  text-transform: capitalize !important;
}

.share_tab_btn_group .active_btn {
  border-bottom: 3px solid #27cdcd !important;
  color: #27cdcd !important;
}

.css-1v91v3i-MuiPaper-root-MuiCard-root {
  overflow: visible !important;
}

.css-1v91v3i-MuiPaper-root-MuiCard-root,
.css-1fua316-MuiPaper-root-MuiCard-root,
.css-1oitmrd-MuiButtonBase-root-MuiCardActionArea-root {
  color: gray !important;
}

.folder_col {
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/Assets/components/documents/docDashboard.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;EACA,aAAA;AAAJ;;AAMA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;AAHJ;;AAMA;EACI,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,aAAA;EACA,sCAAA;EACA,yBAAA;AAHJ;;AAMA;;EAEI,oCAAA;EACA,8BAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,oCAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,eAAA;EACA,0BAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,eAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,YAAA;AAHJ;;AAMA;EACI,6CAAA;AAHJ;;AAMA;EACI,2CAAA;AAHJ;;AAMA;EACI,sCAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,uBAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,wBAAA;EACA,sCAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,OAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,kCAAA;AAHJ;;AAMA;EACI,kCAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;AAHJ;;AAMA;EACI,2CAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;;;EAGI,sBAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ","sourcesContent":["// Global styles start\ninput:focus {\n    box-shadow: none !important;\n    outline: none;\n    // border: 1px solid lightgray !important;\n}\n\n// Global styles end\n\n.documents_dashboard {\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n}\n\n.search_wrapper {\n    height: 50px;\n}\n\n.search_span {\n    background-color: white;\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    color: gray;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.search_wrapper input {\n    border-left: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.search_wrapper input:focus {\n    box-shadow: none !important;\n    outline: none;\n    border: 1px solid lightgray !important;\n    border-left: 0 !important;\n}\n\n.dashboard_search_btn,\n.dashboard_add_filetype_btn {\n    background-color: #27cdcd !important;\n    border-radius: 10px !important;\n    color: white !important;\n}\n\n.dashboard_upgrade_storage_btn {\n    color: #2ccece !important;\n    background-color: #edfafa !important;\n    border-radius: 10px !important;\n}\n\n.add_doc_btn {\n    width: 140px !important;\n    height: auto;\n    background-color: #27cdcd !important;\n    border-radius: 10px !important;\n    font-size: 12px;\n    text-transform: capitalize;\n}\n\n.add_folder_btn {\n    width: auto !important;\n    height: auto;\n    background-color: #edae49 !important;\n    border-radius: 10px !important;\n    font-size: 11px;\n}\n\n.bg_doc_theme {\n    background-color: #27cdcd !important;\n    color: white;\n}\n\n.add_folder_plus:hover {\n    background-color: rgb(25, 196, 25) !important;\n}\n\n.add_folder_cross:hover {\n    background-color: rgb(185, 9, 9) !important;\n}\n\n.tbl_container {\n    border: 1px solid lightgray !important;\n    padding-left: 10px;\n    padding-bottom: 30px;\n    border-radius: 10px !important;\n}\n\n.edited_img {\n    object-fit: cover !important;\n}\n\n.edited_media {\n    position: relative;\n}\n\n.edited_img_type {\n    position: absolute;\n    height: 30px !important;\n    width: 30px !important;\n}\n\n.ftype_icon1 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {\n    background-color: #725dff !important;\n}\n\n.ftype_icon2 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {\n    background-color: #458df9 !important;\n}\n\n.ftype_icon3 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {\n    background-color: #67ada4 !important;\n}\n\n.ftype_icon4 .css-18rm664-MuiButtonBase-root-MuiIconButton-root {\n    background-color: #df562e !important;\n}\n\n.disable_box_shadow:focus {\n    box-shadow: none !important;\n    outline: none !important;\n    border: 1px solid lightgray !important;\n}\n\n.roles_image1 {\n    height: 27px;\n    width: 27px;\n    left: 0;\n}\n\n.roles_image2 {\n    height: 27px;\n    width: 27px;\n    margin-left: -12px;\n}\n\n.roles_image3 {\n    height: 27px;\n    width: 27px;\n    margin-left: -12px;\n}\n\n.count_rounded {\n    height: 25px;\n    width: 25px;\n    background-color: #27cdcd;\n    color: white;\n    border: 2px solid white;\n    border-radius: 40px;\n    margin-left: -10px;\n    font-size: 80%;\n}\n\n.share_tab_btn_group {\n    box-shadow: none !important;\n    border-bottom: 1px solid lightgray;\n}\n\n.share_tab_btn_group .tab_btn {\n    background-color: white !important;\n    border-radius: 0 !important;\n    color: gray;\n    font-size: 18px;\n    font-weight: bold;\n    text-transform: capitalize !important;\n}\n\n.share_tab_btn_group .active_btn {\n    border-bottom: 3px solid #27cdcd !important;\n    color: #27cdcd !important;\n}\n\n.css-1v91v3i-MuiPaper-root-MuiCard-root {\n    overflow: visible !important;\n}\n\n.css-1v91v3i-MuiPaper-root-MuiCard-root,\n.css-1fua316-MuiPaper-root-MuiCard-root,\n.css-1oitmrd-MuiButtonBase-root-MuiCardActionArea-root {\n    color: gray !important;\n}\n\n.folder_col {\n    height: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
